import { useCallback, useState } from 'react';

export type BrightnessPanelProps = {
	isVisible: boolean;
	onBrightnessChange: (value: number) => void;
};

const PANEL_STYLES: React.CSSProperties = {
	position: 'absolute',
	bottom: '16px',
	left: '16px',
	zIndex: 100,
	backgroundColor: 'rgba(24, 24, 27, 0.88)',
	backdropFilter: 'blur(12px)',
	WebkitBackdropFilter: 'blur(12px)',
	borderRadius: '10px',
	padding: '12px 16px',
	boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
	fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
	color: '#e4e4e7',
	userSelect: 'none',
	minWidth: '200px'
};

const LABEL_STYLES: React.CSSProperties = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	fontSize: '12px',
	fontWeight: 500,
	marginBottom: '8px',
	letterSpacing: '0.02em'
};

const SLIDER_STYLES: React.CSSProperties = {
	width: '100%',
	height: '4px',
	appearance: 'none',
	WebkitAppearance: 'none',
	background: 'linear-gradient(to right, #3f3f46, #fbbf24)',
	borderRadius: '2px',
	outline: 'none',
	cursor: 'pointer'
};

export const BrightnessPanel = (props: BrightnessPanelProps): React.ReactElement | null => {
	const { isVisible, onBrightnessChange } = props;
	const [brightness, setBrightness] = useState(100);

	const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>): void => {
		const value = Number(e.target.value);
		setBrightness(value);
		onBrightnessChange(value / 100);
	}, [onBrightnessChange]);

	if (!isVisible) return null;

	return (
		<div style={PANEL_STYLES}>
			<div style={LABEL_STYLES}>
				<span>Ambient Brightness</span>
				<span style={{ color: '#a1a1aa' }}>{brightness}%</span>
			</div>
			<input
				type="range"
				min={0}
				max={100}
				step={1}
				value={brightness}
				onChange={handleChange}
				style={SLIDER_STYLES}
			/>
		</div>
	);
};
